<template>
  <div class="eds-comp-application-info" @click="showApplication(applicationInfo)">
    <div>
      <v-icon :color="applicationIconColor" style="height: 30px; vertical-align: middle; margin-right: 5px">{{
        applicationIcon }}</v-icon>
      <span style="font-weight: bold">{{ applicationInfo.name }}</span>
      <span style="font-weight: bold" v-if="isDev">({{ applicationInfo.id + $t('测试') }})</span>
    </div>
    <div class="application_content_main">
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请标题') }}</span>
        <span class="eds_content_value">{{ applicationInfo.title }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请描述') }}</span>
        <span class="eds_content_value">{{ applicationInfo.desc }}</span>
      </div>
      <v-divider></v-divider>
      <div class="eds_content_footer">
        <span class="eds-content__time">{{ createDate }}</span>
        <span :class="stepClass" class="eds-content__step">{{ applicationInfo.step }}</span>
      </div>
    </div>
  </div>
</template>


<script>
import msgbus from '../msgBus'
import devHelper from '../util/devHelper'
import debugHelper from '../util/debug'
import dateHelper from '../util/date'
import dbHelper from '../util/db'
import { FLOW_STATE } from '../config/work'

export default {
  name: 'eDSCompApplicationInfo',
  props: {
    applicationInfo: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    isDev() {
      return devHelper.isDevMode() // 判断是否开启了测试模式
    },
    applicationIcon() {
      return this.applicationInfo
        ? FLOW_STATE[this.applicationInfo.state].icon
        : ''
    },
    applicationIconColor() {
      return this.applicationInfo
        ? FLOW_STATE[this.applicationInfo.state].color
        : ''
    },
    createDate() {
      return dateHelper.timestamp2LocalDate(this.applicationInfo.createTime)
    },
    stepClass() {
      const classes = []
      switch (this.applicationInfo.state) {
        case 'awaiting_approval':
          classes.push('dl-orange')
          break
        case 'approved':
          classes.push('dl-green')
          break
        case 'rejected':
          classes.push('dl-red')
          break
        case 'finished':
        case 'canceled':
          classes.push('dl-gray')
          break
      }
      return classes.join(' ')
    },
  },
  methods: {
    // 显示申请详情
    showApplication(applicationInfo) {
      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('flowListScrollTop', scroll.scrollTop)
      dbHelper.set('flowListRecordCount', msgbus.vm.getFlowListRecordCount())

      let routerName = msgbus.vm.isEDS16() ? 'flowinfo16' : 'flowinfo'
      this.$router.push({
        name: routerName,
        params: {
          flowID: this.applicationInfo.id,
          flowTid: msgbus.vm.getCurrentTenantID(),
        },
      })
    },
  },
  created() {
    console.log('调试代码')
  },
  mounted() { },
}
</script>


<style lang="scss">
.eds-comp-application-info {
  .application_content_main {
    margin-top: 10px;
    margin-left: 30px;
    margin-right: 20px;

    &>.eds_content2 {
      margin-right: 20px;
    }

    & .eds_content_footer {
      position: relative;

      &>.eds-content__time {
        color: rgba(138, 138, 138, 1);
        line-height: 28px;
      }

      &>.eds-content__step {
        margin-left: 20px;
        color: rgba(138, 138, 138, 1);
        line-height: 28px;
      }
    }
  }
}
</style>